module.exports = __webpack_public_path__ + "img/logo.ae70b068.png";